// features/subdomainSlice.js
import { createSlice } from '@reduxjs/toolkit';

const subdomainSlice = createSlice({
  name: 'subdomain',
  initialState: {
    value: null,
  },
  reducers: {
    setSubdomain: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setSubdomain } = subdomainSlice.actions;
export const subdomainSelector = (state) => state.subdomain.value;

export default subdomainSlice.reducer;
